import script from "./Threads.vue?vue&type=script&setup=true&lang=ts"
export * from "./Threads.vue?vue&type=script&setup=true&lang=ts"

import "./Threads.vue?vue&type=style&index=0&id=7f430047&lang=css"

const __exports__ = script;

export default __exports__